import { inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { TranslateLoaderService } from './app/core/services/translate-loader.service';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { loaderInterceptor } from './app/core/interceptors/loader.interceptor';
import { tokenInterceptor } from './app/core/interceptors/token.interceptor';
import { devCacheInterceptor } from './app/core/interceptors/dev-cache.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { accountInterceptor } from './app/core/interceptors/account.interceptor';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app/app.routes';
import { paginatorIntlFactory } from 'src/app/core/providers/paginator-intl.factory';
import { DEFAULT_DATE_FORMATS, EmpDateAdapter } from 'src/app/core/providers/date-adapter';
import { LanguageService } from 'src/app/core/services/language.service';
import { provideHighcharts } from 'highcharts-angular';
import { HIGHCHARTS_CONFIG } from 'src/app/core/config/highcharts.config';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideTranslateService({ loader: provideTranslateLoader(TranslateLoaderService) }),
    provideAppInitializer(() => inject(LanguageService).initialize()),
    { provide: MatPaginatorIntl, useFactory: paginatorIntlFactory },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_SELECT_CONFIG, useValue: { overlayPanelClass: 'emp-select-overlay' } },
    { provide: DateAdapter, useClass: EmpDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DEFAULT_DATE_FORMATS },
    provideHighcharts(HIGHCHARTS_CONFIG),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([tokenInterceptor, loaderInterceptor, devCacheInterceptor, accountInterceptor]))
  ]
}).catch(err => console.error(err));
